module.exports = __webpack_public_path__ + "static/img/防非.a087150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner2/防非.png
// module id = 1IAH
// module chunks = 1